import script from "./EmployeeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeModal.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeModal.vue?vue&type=style&index=0&id=3445649c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3445649c"]])

export default __exports__